import React from 'react';
import { Link } from 'react-router-dom';

const NotFound: React.FC = () => {
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-4">
      <div className="mb-8">
        <svg 
          className="mx-auto h-24 w-24 text-clay-400" 
          fill="none" 
          viewBox="0 0 24 24" 
          stroke="currentColor"
        >
          <path 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth={1.5} 
            d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" 
          />
        </svg>
      </div>
      
      <h1 className="text-4xl font-bold text-pottery-earth mb-4">
        404
      </h1>
      
      <h2 className="text-xl font-semibold text-clay-700 mb-2">
        Seite nicht gefunden
      </h2>
      
      <p className="text-clay-600 mb-8 max-w-md">
        Die gesuchte Seite existiert leider nicht. Vielleicht wurde sie verschoben oder gelöscht.
      </p>
      
      <div className="flex flex-col sm:flex-row gap-4">
        <Link
          to="/"
          className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-pottery-earth hover:bg-pottery-earth-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-pottery-earth transition-colors"
        >
          <svg className="mr-2 h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
          </svg>
          Zum Dashboard
        </Link>
        
        <Link
          to="/products"
          className="inline-flex items-center justify-center px-6 py-3 border border-clay-300 text-base font-medium rounded-md text-clay-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-clay-500 transition-colors"
        >
          <svg className="mr-2 h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
          </svg>
          Inventar ansehen
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
